import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SwitchGrid = styled(Grid)`
  margin-top: -15px;
  justify-content: center;
  align-items: center;
`;